module.exports = __webpack_public_path__ + "static/media/01.a1f6332e.jpg";